module.exports = __webpack_public_path__ + "static/important-rewards-17c68b44990e7e34c356f3e9224ed7ee.png";